import React from 'react';
import { Row, Col, Label } from 'react-bootstrap';
import moment from 'moment';
import { humanize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import HeadingDivider from './HeadingDivider';
class ExceptionDetails extends React.Component {
    render() {
        const { t } = this.props;
        if (!this.props.exception)
            return React.createElement("div", null, t('LOADING'));
        const status = this.props.exception.resolved
            ? t('RESOLVED')
            : t('UNRESOLVED');
        return (React.createElement("div", null,
            React.createElement(HeadingDivider, { text: t('EXCEPTION_STATUS') }),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(Label, { bsStyle: "danger" }, humanize(status)))),
            React.createElement(Row, { style: { paddingTop: 5 } },
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('CREATED'))),
                React.createElement(Col, { md: 9 },
                    moment(this.props.exception.created_at).format('L LT'),
                    " -",
                    ' ',
                    moment(this.props.exception.created_at).fromNow(),
                    "...")),
            React.createElement(Row, null,
                React.createElement(Col, { md: 3 },
                    React.createElement("span", { style: { color: 'gray' } }, t('SUMMARY'))),
                React.createElement(Col, { md: 9 }, this.props.exception.message))));
    }
}
export default withTranslation()(ExceptionDetails);
